<input type="file" class="file-input" (change)="onFileChange($event)" #fileUpload/>

<div class="d-flex flex-row">
  <button type="button" class="btn btn-primary me-2" (click)="fileUpload.click()"><fa-icon [icon]="faUpload"></fa-icon></button>
  <span class="ml-2 mt-2">{{!filePath? 'Seleziona un file': filePath}}</span>
</div>
